module.exports = __webpack_public_path__ + "static/media/intervencion3.dfd8ea6c.webp";